import { MAX_CONTENT_WIDTH, MAX_WIDTH } from "config/resolution";
import styled from "styled-components/macro";

export const Content = styled.div(({ theme, noPadding, fullWidth }) => ({
  padding: !noPadding && "0 16px",
  margin: "auto",

  [theme.breakpoint.lg()]: {
    padding: !noPadding && "0 36px",
  },

  [theme.breakpoint.xl()]: {
    maxWidth: fullWidth ? MAX_WIDTH : MAX_CONTENT_WIDTH,
    padding: !noPadding && "0 112px",
  },
}));
